<template>
  <div class="about">
    <div class="w1320">
      <div class="title wow">
        <div class="cn">欢迎来到博洋生活世界</div>
        <div class="en">Welcome to the world of Beyond</div>
      </div>
      <div class="content wow">
        <div class="quotation">”</div>
        <div class="cn">
          <p>博洋纺织科技有限公司的前身是博洋家纺有限公司团购中心，于2017年正式独立运营。博洋纺织科技集研发、生产、采购、商务、质管、销售等部门于一体，这样能更好地满足客户需求。</p>
        </div>
        <div class="en">
          <p>The predecessor of Boyang Textile Technology Co., Ltd. is the group purchasing center of Boyang Home Textiles Co., Ltd., which was officially</p>
          <p> operated inde pendently in 2017. Boyang Textile Technology integrates R&D, production, procurement, business, quality management, sales and other departments to better meet customer needs.</p>
        </div>
        <div class="button">
          <a href="">
            <span class="text">VIEW MORE</span>
            <img class="icon" src="@/assets/images/button-arrow.png" alt="">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Scrollbar from 'smooth-scrollbar';
export default {
  data(){
		return{
			
		}
  },
  mounted(){
    
  }
}
</script>

<style scoped>
.about{
  padding: 175px 0;
}
.about .title{
  width: 626px;
  max-width: 100%;
  text-align: center;
	animation-name: transition1;
	animation-duration: 1s;
  animation-fill-mode:forwards;
}
.about .title .cn{
  font-family: '宋体';
  font-size: 30px;
  color: #5e7987;
  margin-bottom: 10px;
}
.about .title .en{
  font-family: 'Embassy BT';
  font-size: 20px;
  color: #636363;
}
@keyframes transition1 {
  0% {
    transform: translate(-100px,-100px);
    opacity: 0;
  }
  100% {
    transform: translate(0,0);
    opacity: 1;
  }
}
@keyframes transition2 {
  0% {
    transform: translate(100px,-100px);
    opacity: 0;
  }
  100% {
    transform: translate(0,0);
    opacity: 1;
  }
}
.about .content{
  width: 1070px;
  max-width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
	animation-name: transition2;
	animation-duration: 1s;
  animation-fill-mode:forwards;
}
.about .content .quotation{
  font-family: 'Embassy BT';
  font-size: 90px;
  color: #5e7987;
  width: 632px;
  max-width: 100%;
  align-self: flex-end;
}
.about .content .cn{
  font-size: 14px;
  font-weight: lighter;
  line-height: 30px;
  width: 632px;
  max-width: 100%;
  align-self: flex-end;
  margin-bottom: 50px;
}
.about .content .en{
  font-family: 'Century751';
  font-size: 12px;
  color: #7b7b7b;
}
.about .content .button{
  font-family: 'Century751';
  font-size: 12px;
  transition: .3s;
  align-self: flex-end;
  margin-right: 150px;
  margin-top: 80px;
}
.about .content .button:hover{
  opacity: .7;
}
.about .content .button .icon{
  transition: .3s;
  margin-left: 10px;
}
.about .content .button:hover .icon{
  transform: translateX(10px);
}
@media(max-width: 768px){
  .about{
    padding: 50px 20px;
  }
}
</style>


